import React from "react";

// { themePalette, setThemePalette } - lets any page reach the dark/light
// toggle (e.g. SettingsMenu rendered outside the main Navigationbar)
// without threading it through props.
const ThemeContext = React.createContext();

export { ThemeContext };
